module.exports = __webpack_public_path__ + "img/check-white.29673aa2.svg";